module.exports = __webpack_public_path__ + "img/118860e.jpg";